<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('lang.资金流水') }}</div>
        </div>
        <div class="cont">
            <van-empty :description="$t('moneybag.detailsEmpty')" v-if="listShow"/>
            <div class="detail_box">
                <div class="item" v-for="item in data">
                    <div class="de_wrap">
                        <p class="tit">{{ item[lang] }}</p>
                        <p class="time">{{ item.time }}</p>
                    </div>
                    <div class="price" :class="item.type =='1'?'':'del'"
                         v-html="item.type =='1'?$t('utils.moneyMark')+ parseInt(item.money) : '-'+$t('utils.moneyMark')+parseInt(item.money)"></div>
						 
						
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import {
    DropdownMenu,
    DropdownItem
} from 'vant';

import {Empty} from 'vant';

Vue.use(Empty);
Vue.use(DropdownMenu).use(DropdownItem);

export default {
    name: "moneybag",
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            data: [],
            list: {},
            account: 0,
            option: [],
            listShow: false,
            funds: 0,
            userName: ''
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        Fetch('/user/funds2').then(r => {
            this.option.push({
                text: this.$t('moneybag.types'),
                value: 0
            })
            for (var i in r.data.reason) {
                switch (i) {
                    case "1":
                        r.data.reason[i] = this.$t('moneybag.recharge');
                        break;
                    case "2":
                        r.data.reason[i] = this.$t('moneybag.withdraw');
                        break;
                    case "3":
                        r.data.reason[i] = this.$t('moneybag.give');
                        break;
                    case "4":
                        r.data.reason[i] = this.$t('moneybag.signIn');
                        break;
                    case "5":
                        r.data.reason[i] = this.$t('moneybag.share');
                        break;
                    case "6":
                        r.data.reason[i] = this.$t('moneybag.purchase');
                        break;
                    case "7":
                        r.data.reason[i] = this.$t('moneybag.redPacket');
                        break;
                    case "8":
                        r.data.reason[i] = this.$t('moneybag.reward');
                        break;
                    case "9":
                        r.data.reason[i] = this.$t('moneybag.welfare');
                        break;
                    case "10":
                        r.data.reason[i] = this.$t('moneybag.invite');
                        break;
                    case "11":
                        r.data.reason[i] = this.$t('moneybag.income');
                        break;
                    default:
                        break;

                }
                this.option.push({
                    text: r.data.reason[i],
                    value: i
                })
            }

            this.showError(r.data.list.length);
            this.data = r.data.list;
            this.funds = r.data.money;
            this.userName = r.data.username;
        })
    },
    methods: {
        chooseType(val) {
            if (val == 0) {
                Fetch('/user/funds2').then(r => {
                    this.data = r.data.list;
                    this.showError(r.data.list.length);
                })
            } else {
                Fetch('/user/funds2', {
                    reason_id: val
                }).then(r => {
                    this.data = r.data.list;
                    this.showError(r.data.list.length);
                })
            }
        },
        showError(len) {
            len == 0 ? this.listShow = true : this.listShow = false
        }
    }
};
</script>

<style lang="less" scoped>
.red_top_bg {
  height: 1=44px;
  background: rgb(35, 29, 29) !important;
  color: rgb(239, 216, 196) !important;

  .big_tit {
    color: rgb(239, 216, 196) !important;
  }
}

.cont {
  height: calc(100vh - 44px);
  padding: 10px 0;
  overflow-y: scroll;
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
}

.detail_box {
  width: 96%;
  margin-left: 2%;
  border-radius: 6px;

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 8px;
    background: #231E1F;
    border-radius: 0.375rem;
    border: 1px solid #452f21;
    margin: 6px 0;
    color: #feecd6;

    .de_wrap {
      flex: 2;

      .tit {
        font-size: 14px;
        color: #feecd6;
        line-height: 20px;
        font-weight: bold;
      }

      .time {
        font-size: 12px;
        color: #feecd6;
        line-height: 17px;
        margin-top: 10px;
        opacity: .3;
      }
    }

    .price {
      flex: 1;
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
      text-align: right;
      color: #f12211;
      white-space: nowrap;

      &.del {
        color: #3FAF3E;
      }
    }
  }
}
</style>
